export enum FashionPreferencesKeys {
    FashionStore = 'FASHION_STORE',
    Lounge = 'LOUNGE',
}

export enum FashionPreference {
    Mens = 'mens',
    Womens = 'womens',
}

type FashionPreferencesValues = FashionPreference.Mens | FashionPreference.Womens | undefined;

export type FashionPreferencesGenderValues = 'MALE' | 'FEMALE';

interface Preference {
    key: FashionPreferencesKeys;
    value: FashionPreferencesValues[];
}

export interface FashionPreferences {
    preferences: Preference[];
}
